module.exports = __webpack_public_path__ + "static/img/equity.e77ba8fe.png";